import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogHeader, DialogTitle, } from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import LocationPairForm from './LocationPairForm';
class CreateLocationPairModal extends Component {
    constructor() {
        super(...arguments);
        this.getLabel = () => {
            const { t } = this.props;
            if (!this.props.locationPair) {
                return t('CREATE_LOCATION_PAIR');
            }
            return t('EDIT_LOCATION_PAIR');
        };
        this.handleSave = (locationPair) => this.props.onSave(locationPair);
        this.handleHide = () => this.props.onHide();
    }
    render() {
        return (React.createElement(Dialog, { open: this.props.show, onOpenChange: this.props.onHide },
            React.createElement(DialogContent, { className: "sm:max-w-[900px]" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, this.getLabel())),
                React.createElement(LocationPairForm, { locationPair: this.props.locationPair, onCancel: this.handleHide, onSave: this.handleSave }))));
    }
}
CreateLocationPairModal.propTypes = {
    show: PropTypes.bool.isRequired,
    locationPair: PropTypes.object,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};
export default withTranslation()(CreateLocationPairModal);
